function MergedQuoteResultModel(Util, coverType) {
	var quoteResults = {} ;

	function addQuoteResult(quote) {
		var freq = paymentFrequencyMapping[quote.paymentFrequency] ;
		quoteResults[freq] = quote ;
	}

	function getQuoteResult(paymentFrequency) {
		paymentFrequency = paymentFrequencyMapping[paymentFrequency] || paymentFrequency ; 
		if ( ! quoteResults[paymentFrequency] )
			quoteResults[paymentFrequency] = forgeQuoteResult(paymentFrequency) ;

		return quoteResults[paymentFrequency] ;
	}

	var paymentFrequencyMapping = {
		everyyear : 'annual',
		monthly: 'monthly',
		everyotherweek: 'fortnightly'
	}

	var premiumConstant = {
		monthly : 1.07 / 12 ,
		fortnightly : 1.07 / 27.5 ,
	}

	function forgeQuoteResult(paymentFrequency) {
		var qr = Util.deepClone(quoteResults.annual) ;
		qr.paymentFrequency = paymentFrequency ;
		qr.isForgedPremium = true ;
		if ( qr.quoteResult && qr.quoteResult.totalPremium) {
			qr.quoteResult.totalPremium = qr.quoteResult.totalPremium * premiumConstant[paymentFrequency] * 12 ;
			qr.paymentPlan = qr.paymentPlan || {} ; 
			qr.paymentPlan.installment= qr.quoteResult.totalPremium * premiumConstant[paymentFrequency]; 
		}

		return qr;
	}

	return {
		addQuoteResult: addQuoteResult,
		getQuoteResult: getQuoteResult,
		getAnnual: function() {return getQuoteResult('annual')},
		getMonthly: function() {return getQuoteResult('monthly')},
		getFortnightly: function() {return getQuoteResult('fortnightly')},
	}
}
